import axios, { AxiosResponse } from 'axios';
import {
  CHANGE_CURRENT_PASSWORD_URL,
  LICENCE_KEY_URL,
  SWITCH_COMPANY_URL,
} from './constant';
import {
  SwitchApiRes,
  SwitchReq,
  LicenseReq,
  LicenseApiRes,
  changeCurrentPasswordRes,
  changeCurrentPasswordReq,
} from './types';

export const switchCompany = async (
  payload: SwitchReq
): Promise<AxiosResponse<SwitchApiRes>> => {
  try {
    const response = await axios.post<SwitchApiRes>(
      SWITCH_COMPANY_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const getLicenceKey = async (
  payload: LicenseReq
): Promise<AxiosResponse<LicenseApiRes>> => {
  try {
    // const response = await axios.fetch<LicenseApiRes>(
    //   LICENCE_KEY_URL,
    // //  import.meta.env.APP_LIC_KEY_BASE_URL + "auth/getWebLicenceKey",
    //   payload
    // );
    // return response;

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    };
    const response = await fetch(LICENCE_KEY_URL, requestOptions);
    const data: any = await response.json();
    return data;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

// export const getLicenceKey: MutateFunction<TLicencekey[], Error> = async () => {
//   try {
//     const response = await axios.post(GET_LICENCE_KEY);
//     return response.data.result;
//   } catch (error: any) {
//     throw new Error(error.response?.data.message);
//   }
// };
export const changeCurrentPassword = async (
  payload: changeCurrentPasswordReq
): Promise<AxiosResponse<changeCurrentPasswordRes>> => {
  try {
    const response = await axios.post<changeCurrentPasswordRes>(
      CHANGE_CURRENT_PASSWORD_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
